import React from 'react'
import { Translate } from 'react-localize-redux'

const renderStatus = (params) => {
  return <Translate id={`movePlayers.${params.row.status}`} />
}

export default renderStatus

